import {
  Box,
  Avatar,
  Typography,
  useTheme,
  Tooltip,
  Link,
} from "@mui/material";
import { useGetList } from "ra-core";
import * as React from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import PersonIcon from "@mui/icons-material/Person";
import DashboardCard from "./DashboardCard";
import { useNavigate } from "react-router";

export function NewCustomerList(props) {
  const { sx, rest, days = 7 } = props;

  const [filter, setFilter] = React.useState({});

  React.useEffect(() => {
    setFilter({
      "created_at.from": new Date(
        Date.now() - days * 24 * 60 * 60 * 1000
      ).toISOString(),
    });
  }, []);

  const { data } = useGetList("admin/users", {
    pagination: { page: 1, perPage: 10 },
    sort: { field: "created_at", order: "DESC" },
    filter: filter,
  });

  return (
    <DashboardCard
      {...rest}
      sx={sx}
      title="New customers"
      subheader={`in the last ${days} days`}
    >
      {data?.map((user, index) => {
        return <NewCustomerCard user={user} key={index} />;
      })}
    </DashboardCard>
  );
}

function NewCustomerCard({ user }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const goToUser = (id) => {
    navigate(`/admin/users/${id}`);
  };
  return (
    <Box
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        margin: "10px",
      }}
      onClick={() => goToUser(user.id)}
    >
      <Avatar>
        <PersonIcon />
      </Avatar>
      <Box sx={{ marginLeft: "30px" }}>
        <Typography>{`${user.first_name} ${user.last_name}`}</Typography>
        <Typography color="text.secondary">{user.email}</Typography>
      </Box>

      {user.verified === true ? (
        <Tooltip placement="top" title="Verified">
          <Avatar
            sx={{
              marginLeft: "auto",
              height: "20px",
              width: "20px",
              bgcolor: theme.palette.primary.main,
            }}
          >
            <CheckOutlinedIcon
              sx={{
                height: "15px",
                width: "15px",
              }}
            />
          </Avatar>
        </Tooltip>
      ) : null}
    </Box>
  );
}
